import { ComponentStyleConfig } from "@chakra-ui/react";

const ContentBlockTheme: ComponentStyleConfig = {
  baseStyle: {
    body: {
      ".mb-content-block__no-header &": {
        pt: "48px",
      },
    },
  },
  variants: {
    form: {
      body: {
        mx: "64px",
        maxWidth: "560px",
        px: 0,
      },
    },
    descriptions: {
      body: {
        maxWidth: "744px",
        mx: "64px",
        px: 0,
      },
    },
  },
};

export default ContentBlockTheme;
